"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var WidgetList_1 = __importDefault(require("./WidgetList"));
var HomeFooter_1 = __importDefault(require("./HomeFooter"));
var SecondaryFooter_1 = __importDefault(require("./SecondaryFooter"));
var classnames_1 = __importDefault(require("classnames"));
var AppFooter = function (_a) {
    var _b = _a.layout, layout = _b === void 0 ? 'HOME' : _b;
    var layoutClass = 'layout-' + layout.toLowerCase();
    return (react_1.default.createElement("div", { className: "app-footer" },
        react_1.default.createElement("div", { className: classnames_1.default('footer-box', layoutClass) },
            react_1.default.createElement(WidgetList_1.default, { isSubscriptionWidget: layout === 'HOME' }),
            layout === 'HOME' && react_1.default.createElement(HomeFooter_1.default, null),
            (layout === 'PREVIEW' || layout === 'SECONDARY') && (react_1.default.createElement(SecondaryFooter_1.default, null)))));
};
exports.default = AppFooter;
